import React from 'react';

function DirectionDetails(props) {
    return <div>To Be Implemented</div>;
}

DirectionDetails.propTypes = {};

export default DirectionDetails;
